<template>
    <el-dialog :title="look ? '银行卡信息' : '绑定银行卡'" :visible="visible" :append-to-body="true" center
        :wrapper-closable="false" direction="rtl" @open="onOpen" width="550px" @update:visible="onCancel">
        <div class="form-drawer-content" v-if="!look">
            <el-form :model="bankInfo" ref="dataForm" class="label-left" label-width="140px">
                <el-form-item prop="bankAccountName"
                    :rules="[{ required: true, message: `请您填写${displayName.userName}` }]"
                    :label="`${displayName.userName}`">
                    <el-input v-model="bankInfo.bankAccountName" :disabled="disabledType" maxlength="250"></el-input>
                </el-form-item>
                <el-form-item :label="`${displayName.bankName}`" prop="bankName"
                    :rules="[{ required: true, message: `请选择${displayName.bankName}` }]">
                    <!--<el-select v-model="bankInfo.bankName" :filterable="true" @change="setbankTypeCode" :remote="true"
                        :disabled="disabledType" :remote-method="(val) => remoteBank(val, 1)"
                        :loading="bankTypeLoading">
                        <el-option v-for="(label, index) in bankTypeOptions" :key="index" :label="label"
                            :value="label"></el-option>
                    </el-select>-->
                    <el-select v-model="bankInfo.bankName" :placeholder="`请选择${displayName.bankName}`"
                        :disabled="disabledType">
                        <el-option v-for="(item, index) in bankList" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="name" :label="`${displayName.childBankName}`"
                    :rules="[{ required: true, message: `请输入${displayName.childBankName}` }]">
                    <!--<el-select v-model="bankInfo.name" :filterable="true" :remote="true" :allow-create="true"
                        :remote-method="(val) => remoteBank(val, 2)" :loading="bankTypeLoading" :disabled="disabledType"
                        :placeholder="`请输入${displayName.childBankName}`">
                        <el-option v-for="(label, index) in bankCodeOptions" :key="index" :label="label"
                            :value="label"></el-option>
                    </el-select>-->
                    <el-input v-model="bankInfo.name" :placeholder="`请输入${displayName.childBankName}`" maxlength="250"
                        :disabled="disabledType"></el-input>
                </el-form-item>
                <el-form-item prop="account" label="银行卡号" :rules="[
                    { required: true, message: '请输入银行卡号' },
                    { pattern: /^[0-9]\d*$/, message: '请正确填写银行账号' },
                ]">
                    <el-input v-model="bankInfo.account" placeholder="请输入银行卡号" maxlength="250"
                        :disabled="disabledType"></el-input>
                </el-form-item>
                <el-form-item v-if="!disabledType">
                    <el-button @click="onCancel">取消</el-button>
                    <el-popover placement="top" width="300" style="margin-left: 10px" v-model="isPopover">
                        <p>银行卡设置后，不可自行更改，请确认信息正确，如后续需要修改，请联系客服；</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="isPopover = false">返回，再次查看</el-button>
                            <el-button type="primary" size="mini" @click="
                                isPopover = false;
                            onSubmit();
                            ">
                                确定
                            </el-button>
                        </div>
                        <el-button type="primary" slot="reference">保存</el-button>
                    </el-popover>
                </el-form-item>
            </el-form>
        </div>
        <div class="sr-descriptions" v-else style="width: auto;">
            <div class="item">
                <label>对公账户名</label>
                <div class="text">{{ bankInfo.bankAccountName }}</div>
            </div>
            <div class="item">
                <label>总行银行名称</label>
                <div class="text">{{ bankInfo.bankName }}</div>
            </div>
            <div class="item">
                <label>开户行名称</label>
                <div class="text">{{ bankInfo.name }}</div>
            </div>
            <div class="item">
                <label>卡号</label>
                <div class="text">{{ bankInfo.account }}</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { queryBank } from '@/api/user';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        look: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataLoading: false,
            bankInfo: {},
            isPopover: false,
            bankList: [
                '中国工商银行',
                '中国银行',
                '中国建设银行',
                '中国农业银行',
                '交通银行',
                '招商银行',
                '兴业银行',
                '中信银行',
                '中国邮政储蓄银行',
                '浦发银行',
                '中国民生银行',
                '中国光大银行',
                '平安银行',
                '华夏银行',
                '宁波银行',
                '广发银行',
                '江苏银行',
                '上海银行',
                '北京银行',
                '南京银行',
            ],
            province: [],
            city: [],
            disabledType: false,
            bankTypeCode: '',
            bankTypeOptions: [], // 银行类型列表
            bankTypeSourceOptions: [], // 银行总行数据源
            bankTypeLoading: false,
            bankCodeOptions: [], // 支行列表
            bankCodeLoading: false,
        };
    },
    computed: {
        displayName() {
            const { userType } = this.$store.state;
            return {
                userName: userType == 1 ? '持卡人' : '对公账号名',
                bankName: userType == 1 ? '银行' : '总行银行名称',
                childBankName: userType == 1 ? '开户网点' : '开户行名称',
            };
        },
    },
    created() {
        // this.getProvince();
    },
    methods: {
        setbankTypeCode(label) {
            const item = this.bankTypeSourceOptions.find((row) => row.label == label);
            if (item) this.bankTypeCode = item.value;
        },
        onOpen() {
            this.getDataDetail();
        },
        onCancel() {
            this.$emit('update:visible', false);
        },
        // //获取所有省份
        // async getProvince() {
        //     const res = await fetchProvince({}).catch(() => {});
        //     const {state, result} = res.data;
        //     if (state == 1) {
        //         this.province = result;
        //     }
        // },
        // //获取城市
        // async getCityList(provinceCode, cityCode) {
        //     const bankInfo = JSON.parse(JSON.stringify(this.bankInfo));
        //     const res = await fetchCityList(provinceCode).catch(() => {});
        //     const {state, result} = res.data;
        //     if (state == 1 && result && result.length > 0) {
        //         this.city = result;
        //         bankInfo.cityCode = cityCode ? cityCode : result[0].id;
        //     }
        //     this.bankInfo = bankInfo;
        // },
        /**
         * 查询银行信息
         * @param {String} query 银行名关键字
         * @param {Number} type 查询银行类型 1：总行名称 2：支行名称
         */
        async remoteBank(query, type) {
            if (!query) return type == 1 ? (this.bankTypeOptions = []) : (this.bankCodeOptions = []);
            type == 1 ? (this.bankTypeLoading = true) : (this.bankCodeLoading = true);
            const res = await queryBank(query, type == 1 ? '' : this.bankTypeCode).finally(() => {
                type == 1 ? (this.bankTypeLoading = false) : (this.bankCodeLoading = false);
            });
            if (!res.data.state) return this.$message.error(res.data.msg);
            if (type == 1) this.bankTypeSourceOptions = (res.data.result || []).map((item) => ({ label: item.name, value: item.code }));
            const remoteOptions = (res.data.result || []).map((item) => item.name);
            type == 1 ? (this.bankTypeOptions = remoteOptions) : (this.bankCodeOptions = remoteOptions);
        },
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: '/org/view/go_org_bank_info',
                params: {},
                method: 'post',
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.bankInfo = result || {};
                        // if (result.cityCode) this.getCityList(result.provinceCode, result.cityCode);
                        if (result.enableEdit === 0) this.disabledType = true;
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        onSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) this.sendData();
            });
        },
        sendData() {
            this.dataLoading = true;
            this.$request({
                url: '/org/bank/save',
                method: 'POST',
                formData: false,
                data: this.bankInfo,
            }).then((response) => {
                const { state, msg } = response.data;
                this.dataLoading = false;
                if (!state) {
                    return this.$message.error(msg);
                } else {
                    this.$message.success('修改成功');
                    this.$emit('update:visible', false);
                    this.$emit('save-success', this.bankInfo);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.describe {
    .title {
        font-weight: 600;
        color: #000;
        line-height: 16px;
        font-size: 16px;
        margin-bottom: 30px;
        margin-top: 30px;
    }

    p {
        font-weight: 400;
        color: #333;
        line-height: 14px;
        font-size: 14px;
        line-height: 30px;
    }

    .error {
        margin-top: 30px;
        color: #de2c2c;
    }
}
</style>
